import { Component, inject, output, signal } from '@angular/core';
import { ComponentsModule } from '@shared/components/components.module';
import { InputSelectInterface } from '@shared/components/form/input-select/input-select.interface';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ProgramTargetService } from '../../services/program-target.service';
import { ProgressTypeFilterValues } from '../../interfaces/tab-program-target.interface';
import { BehaviorSubject } from 'rxjs';

export const PROGRESS_TYPE_FILTER_VALUES = ['IN_PROGRESS', 'DONE'] as const;

@Component({
  selector: 'app-program-target-filter',
  host: {
    class: 'd-flex w-100 justify-content-between align-items-center',
  },
  standalone: true,
  imports: [ComponentsModule],
  templateUrl: './program-target-filter.component.html',
  styleUrl: './program-target-filter.component.scss',
})
export class ProgramTargetFilterComponent {
  readonly service = inject(ProgramTargetService);

  dataSource = this.service.dataSource;

  isFinishLoading = new BehaviorSubject<boolean>(true);
  isFilterActive = signal<boolean>(false);
  isFilterOpen = signal<boolean>(false);

  readonly actionSearch = output<string>();
  readonly actionApplyFilter = output<ProgressTypeFilterValues | undefined>();

  filterForm = new FormGroup({
    progressTypeFilterControl: new FormControl<ProgressTypeFilterValues | null>(null, [Validators.required]),
  });

  readonly filterOptions: InputSelectInterface[] = [
    {
      value: PROGRESS_TYPE_FILTER_VALUES[0],
      display: 'Sedang Berjalan',
    },
    {
      value: PROGRESS_TYPE_FILTER_VALUES[1],
      display: 'Menyelesaikan Target/Mendapat Hadiah',
    },
  ];

  handleOpenFilter() {
    this.isFilterOpen.update((val) => !val);
  }

  handleResetFilter(): void {
    this.filterForm.reset({
      progressTypeFilterControl: null,
    });
    this.actionApplyFilter.emit(undefined);
    this.isFilterActive.set(false);
    this.isFilterOpen.set(false);
  }

  handleApplyFilter(): void {
    if (this.filterForm.invalid) {
      return;
    }
    const progressType = this.filterForm.controls.progressTypeFilterControl.value;
    this.actionApplyFilter.emit(progressType ?? undefined);
    this.isFilterActive.set(true);
    this.isFilterOpen.set(false);
  }

  handleSearch(value: string) {
    this.actionSearch.emit(value);
  }
}
